import { Injectable } from '@angular/core';

// Angular material
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

// Generic dialogs
import { DecisionPopupComponent } from '../../components/popups/decision-popup/decision-popup.component';
import { PatientIdPopupComponent } from '../../components/popups/patient-id-popup/patient-id-popup.component';

// External modules
import { saveAs } from 'file-saver';



@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private _snackBar: MatSnackBar,
    public dialog:MatDialog,
  ) {}


  displaySnackBar(message:string){
    this._snackBar.open(message, '', {
      duration: 3000,
      horizontalPosition:'center',
      verticalPosition:'bottom',
    });
  }

  deepCopyDict(inputArray:any){
    return JSON.parse(JSON.stringify(inputArray));
  }

  displayDecisionPopup(popupTitle:string, popupText:string, targetCallbackMethod: (data: any) => void){
    this.dialog.open(
      DecisionPopupComponent, 
      {
        disableClose: true,
        data: {popupTitle:popupTitle, popupText:popupText},
        width: '500px',
      } 
    ).afterClosed().subscribe(result => targetCallbackMethod(result))
  }

  async fetchBinaryFile(url: string): Promise<Uint8Array> {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const buffer = await response.arrayBuffer();
    return new Uint8Array(buffer);
  }

  downloadFile(url: string, filename: string) {
    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.blob();
        })
        .then(blob => {
            saveAs(blob, filename);
        })
        .catch(error => console.error(error));
  }

  displayPatientIdPopup(targetCallbackMethod: (data: any) => void){
    this.dialog.open(
      PatientIdPopupComponent, 
      {
        disableClose: true,
        data: {proposedPatientId:'', proposedStudyId:''},
        width: '500px',  
      } 
    ).afterClosed().subscribe(result => targetCallbackMethod(result))
  }

}
